import { useTranslation } from 'next-i18next'
import Layout from '../components/layouts/AppLayout'
import Head from 'next/head'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

export default function TermsOfConditionsSeller () {
  const { t } = useTranslation(['about', 'header', 'footer'])

  return (
    <Layout variant="white">
      <Head>
        <title>{t('meta.title')}</title>
      </Head>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10 col-xl-8">
            <h1 className="text-dark">{t('title')}</h1>
            <p>{t('p1')}</p>
            <p>{t('p2')}</p>
            <p>{t('p3')}</p>
            <p>{t('p4')}</p>
            <p>{t('p5')}</p>
            <p>{t('p6')}</p>
            <p>{t('p7')}</p>
            <p>{t('p8')}</p>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export async function getServerSideProps ({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['about', 'header', 'footer', 'languages', 'applications', 'routes']))
    }
  }
}
